module.exports = __webpack_public_path__ + "img/loading.67b2b353.svg";